import React, { useEffect, useState } from 'react';
import Home from './Portfolio/Home';
import { Icon } from '@iconify/react';

function App() {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let progressInterval;
    if (loading) {
      progressInterval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(progressInterval);
            setLoading(false);
            return 100;
          }
          return prevProgress + (100 / 7); // Increase progress every second over 7 seconds
        });
      }, 1000);
    }

    return () => clearInterval(progressInterval); // Clean up interval on unmount
  }, [loading]);

  return (
    <>
      {/* {loading ? (
        <div className="flex flex-col justify-center items-center h-screen bg-gradient-to-r from-gray-950 to-black text-white text-center">
          <div className="w-2/4 h-4 bg-gray-800 rounded-full overflow-hidden shadow-lg">
            <div
              className="bg-gradient-to-r from-gray-700 to-gray-400 h-full"
              style={{ width: `${progress}%`, transition: 'width 1s ease-in-out' }}
            ></div>
          </div>

          <div className="mt-8 text-gray-300">
            <p className="text-3xl italic font-semibold flex flex-row gap-2 items-center">
              <span>"Hang tight, greatness is loading... don’t forget to smile!"</span>
            </p>
            <span className="mt-4 block text-sm text-gray-500">— Crafted with Passion</span>
          </div>

          <div className="mt-8">
            <Icon icon="line-md:loading-loop" className="text-blue-500 text-5xl animate-spin-slow" />
          </div>
        </div>
      ) : ( */}
        <Home />
      {/* )} */}
    </>
  );
}

export default App;
